// images
import blogImg1 from "../images/service/warehouse.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/service/roadfreight.jpg";
import blogImg4 from "../images/blog/img-4.jpg";
import blogImg5 from "../images/blog/img-5.jpg";
import blogImg6 from "../images/blog/img-6.jpg";
import blogImg7 from "../images/blog/img-7.jpg";
import blogImg8 from "../images/blog/img-8.jpg";
import blogImg9 from "../images/blog/img-9.jpg";

import blogSingleImg1 from "../images/blog/img-11.jpg";
import blogSingleImg2 from "../images/international-freight.jpg";
import blogSingleImg3 from "../images/project-logistics.jpg";

import blogGlImg1a from "../images/blog-details/img-2.jpg";
import blogGlImg1b from "../images/service/warehouse.jpg";
import blogGlImg1c from "../images/service/seafreight.jpg";
import blogGlImg2a from "../images/service/seafreight.jpg";
import blogGlImg2b from "../images/international-freight.jpg";
import blogGlImg2c from "../images/service/warehouse.jpg";
import blogGlImg3a from "../images/project-logistics.jpg";
import blogGlImg3b from "../images/service/roadfreight.jpg";
import blogGlImg3c from "../images/warehousing.jpg";

import SingleImg1 from "../images/recent-posts/img-1.jpg";
import SingleImg2 from "../images/recent-posts/img-2.jpg";
import SingleImg3 from "../images/recent-posts/img-3.jpg";




const blogs = [
    {
        id: '1',
        title: 'Streamlining Global Supply Chains Our Logistics Solutions',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Transport',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg1,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Roger J. Spaulding',
        create_at: 'Sep 20, 2024',
        blogSingleImg: blogSingleImg1,
        glImg1: blogGlImg1a,
        glImg2: blogGlImg1b,
        glImg3: blogGlImg1c,
        SingleImg: SingleImg1,
        comment: '5',
        day: '20',
        month: 'Sep',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori:'Food and Beverages',
        content1: 'Global supply chains succeed when every handoff—from origin warehouse to final delivery—is planned, visible, and controlled. Our logistics solutions connect freight, customs, and last-mile partners so goods move with fewer delays and clearer accountability across borders.',
        content2: 'By aligning inventory planning with multimodal transport, businesses reduce dwell time at ports and hubs. Real-time tracking and proactive exception handling help teams respond before small disruptions become costly bottlenecks.',
        content3: 'Whether you ship high-volume commodities or time-sensitive freight, a streamlined network improves reliability, lowers landed cost, and strengthens customer trust through predictable delivery performance.',
        quote: 'A resilient supply chain is not built on speed alone—it is built on visibility, coordination, and the right partners at every mile.',
        quoteAuthor: 'Roger J. Spaulding',
        sectionTitle: 'How our logistics solutions simplify global trade',
        points: [
            'End-to-end visibility across ocean, air, and road freight.',
            'Coordinated customs clearance and documentation support.',
            'Optimized routing to reduce transit time and cost.',
            'Proactive alerts for delays, capacity shifts, and exceptions.',
            'Scalable fulfillment aligned with seasonal demand peaks.',
        ],
        content4: 'Streamlining global supply chains starts with the right logistics partner. With integrated planning, transparent operations, and dependable delivery networks, your business can move goods worldwide with confidence and control.',
        tags: ['Logistics', 'Supply Chain', 'Transport', 'Freight'],
    },
    {
        id: '2',
        title: 'Lead Analyst for Transportation Network and Logistics',
        title2: 'Will supply chains become supply circles?',
        tag: 'Transport',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg2,
        description: 'It was with the release sheets containing passages more software.',
        author: 'James K. Harlan',
        create_at: 'Aug 14, 2024',
        blogSingleImg: blogSingleImg2,
        glImg1: blogGlImg2a,
        glImg2: blogGlImg2b,
        glImg3: blogGlImg2c,
        SingleImg: SingleImg2,
        comment: '8',
        day: '14',
        month: 'Aug',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
        content1: 'A lead analyst for transportation networks turns complex freight data into clear operating decisions. From lane performance to carrier capacity, analytical insight helps logistics teams balance cost, service levels, and network risk.',
        content2: 'Modern transportation analysis covers demand forecasting, route efficiency, hub utilization, and service reliability. When these signals are reviewed together, organizations can redesign networks that perform under pressure.',
        content3: 'Strong analysis does more than report past results—it guides where to add capacity, which partners to prioritize, and how to protect critical lanes before disruptions occur.',
        quote: 'Transportation excellence begins with measurement. What you track, model, and act on becomes the strength of your logistics network.',
        quoteAuthor: 'James K. Harlan',
        sectionTitle: 'What a transportation network analyst focuses on',
        points: [
            'Lane-level performance and cost-to-serve analysis.',
            'Carrier scorecards for on-time and damage rates.',
            'Network modeling for hubs, cross-docks, and regions.',
            'Scenario planning for peak seasons and disruptions.',
            'Data-driven recommendations for route and mode shifts.',
        ],
        content4: 'In transportation and logistics, leadership is powered by insight. A disciplined analyst role helps companies build smarter networks, negotiate from facts, and deliver consistent service across every corridor.',
        tags: ['Transport', 'Analytics', 'Logistics', 'Network'],
    },
    {
        id: '3',
        title: 'Efficient Transport Management Strategies for Businesses',
        title2: 'We ensures you the best quality services',
        tag: 'Transport',
        slug: 'Why-Industry-Are-A-Juicy',
        screens: blogImg3,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Maria L. Benton',
        create_at: 'Jul 08, 2024',
        blogSingleImg: blogSingleImg3,
        glImg1: blogGlImg3a,
        glImg2: blogGlImg3b,
        glImg3: blogGlImg3c,
        SingleImg: SingleImg3,
        comment: '12',
        day: '08',
        month: 'Jul',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'Efficient transport management helps businesses move products faster while controlling spend. The strongest strategies combine clear planning, reliable carriers, and technology that keeps every shipment accountable from pickup to proof of delivery.',
        content2: 'Companies that standardize processes—booking, load planning, tracking, and billing—reduce operational noise and free teams to focus on service quality. Consolidation, smarter mode selection, and route optimization all contribute to leaner transport costs.',
        content3: 'When transport management is treated as a strategic function rather than a back-office task, businesses gain better visibility, fewer surprises, and a more resilient delivery experience for customers.',
        quote: 'Transport efficiency is not about moving less—it is about moving smarter, with clearer processes and measurable outcomes.',
        quoteAuthor: 'Maria L. Benton',
        sectionTitle: 'Practical strategies for stronger transport operations',
        points: [
            'Centralize shipment planning and carrier communication.',
            'Use consolidation and load optimization to cut empty miles.',
            'Select modes based on urgency, cost, and service needs.',
            'Track KPIs such as on-time delivery and cost per mile.',
            'Build contingency plans for peak demand and disruptions.',
        ],
        content4: 'Businesses that invest in efficient transport management strategies protect margins and customer trust. With disciplined planning and continuous improvement, every load becomes more predictable and cost-effective.',
        tags: ['Transport', 'Management', 'Logistics', 'Business'],
    },
    
    {
        id: '4',
        title: 'Principal Transportation and Logistics Network',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy4',
        screens: blogImg4,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Roger J. Spaulding',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'A principal transportation and logistics network is the backbone of reliable commerce. It connects origin points, distribution hubs, and destination markets through coordinated modes, partners, and operating standards.',
        content2: 'Well-designed networks balance coverage with efficiency. Strategic hub placement, clear service lanes, and consistent handoff processes keep freight flowing even when demand or capacity shifts.',
        content3: 'Organizations that treat their logistics network as a core asset unlock faster cycle times, stronger regional reach, and better control over customer delivery promises.',
        quote: 'Your logistics network is only as strong as the connections between each node—plan those links with intention.',
        quoteAuthor: 'Roger J. Spaulding',
        sectionTitle: 'Building a high-performing logistics network',
        points: [
            'Map critical lanes and capacity across key markets.',
            'Align hub locations with demand density and lead times.',
            'Standardize handoffs between carriers and warehouses.',
            'Monitor network health with on-time and dwell metrics.',
            'Scale regional coverage without sacrificing service quality.',
        ],
        content4: 'A principal transportation and logistics network gives businesses the structure to grow. With clear design and disciplined execution, freight moves farther, faster, and with greater confidence.',
        tags: ['Transport', 'Logistics', 'Network', 'Freight'],
    },
    {
        id: '5',
        title: 'Chief Transportation and Fleet Management',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy5',
        screens: blogImg5,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Roger J. Spaulding',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'Chief transportation and fleet management roles focus on keeping vehicles, drivers, and routes productive every day. Strong fleet leadership reduces downtime, improves safety, and protects delivery commitments.',
        content2: 'Effective fleet programs cover maintenance schedules, fuel efficiency, driver performance, and asset utilization. When these areas work together, operating costs drop and service reliability rises.',
        content3: 'From compliance to route planning, modern fleet management turns daily transportation work into a measurable, improvable system that supports business growth.',
        quote: 'A well-managed fleet does more than move freight—it protects schedules, budgets, and brand reputation on the road.',
        quoteAuthor: 'Roger J. Spaulding',
        sectionTitle: 'Priorities for transportation and fleet leaders',
        points: [
            'Preventive maintenance to minimize unexpected downtime.',
            'Route planning that improves utilization and fuel use.',
            'Driver coaching focused on safety and on-time performance.',
            'Telematics insights for utilization and exception alerts.',
            'Compliance tracking for inspections and documentation.',
        ],
        content4: 'Chief transportation and fleet management success comes from discipline and visibility. With the right processes in place, every mile contributes to safer, more efficient logistics operations.',
        tags: ['Fleet', 'Transport', 'Management', 'Logistics'],
    },
    {
        id: '6',
        title: 'Complete Guide to Business Insurance perfect',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy6',
        screens: blogImg6,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Roger J. Spaulding',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'A complete guide to business insurance helps organizations protect people, assets, and operations against unexpected loss. The right coverage mix reduces financial risk while supporting confident day-to-day decision making.',
        content2: 'From liability and property protection to cargo and interruption coverage, businesses need policies aligned with how they actually work. Gaps in coverage often appear only after a claim—planning ahead prevents that exposure.',
        content3: 'Reviewing limits, exclusions, and partner requirements regularly keeps insurance practical and current as the business scales into new markets or services.',
        quote: 'Insurance is not just a policy file—it is a business continuity plan written before you need it.',
        quoteAuthor: 'Roger J. Spaulding',
        sectionTitle: 'Key areas to review in business insurance',
        points: [
            'Match coverage to real operational and cargo risks.',
            'Review liability limits as contracts and volumes grow.',
            'Confirm property, equipment, and warehouse protection.',
            'Assess business interruption and contingent risk needs.',
            'Update policies after major process or market changes.',
        ],
        content4: 'The complete path to stronger business insurance starts with understanding risk and closing coverage gaps. With the right guide and regular reviews, your organization stays protected while it grows.',
        tags: ['Insurance', 'Business', 'Risk', 'Protection'],
    },
    
    {
        id: '7',
        title: 'Principal Transportation and Logistics Network',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy7',
        screens: blogImg5,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Roger J. Spaulding',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'A principal transportation and logistics network creates the structure needed for consistent, scalable freight movement. It links suppliers, carriers, warehouses, and customers into one coordinated operating model.',
        content2: 'Network strength comes from clear lane design, reliable partner performance, and the ability to reroute when conditions change. Visibility across nodes makes that agility possible.',
        content3: 'Companies that continuously refine their logistics network improve service levels while controlling cost-to-serve across regions and product lines.',
        quote: 'Great logistics networks are designed for both daily flow and unexpected change.',
        quoteAuthor: 'Roger J. Spaulding',
        sectionTitle: 'Essentials of a principal logistics network',
        points: [
            'Define primary and alternate lanes for critical freight.',
            'Connect warehouse capacity with transportation schedules.',
            'Evaluate partners on reliability, not price alone.',
            'Use network data to remove recurring bottlenecks.',
            'Expand coverage with controlled, staged growth.',
        ],
        content4: 'Building a principal transportation and logistics network is an ongoing investment. With the right design and operating discipline, your organization can deliver farther and more reliably.',
        tags: ['Transport', 'Logistics', 'Network', 'Freight'],
    },
    
    {
        id: '8',
        title: 'We ensures you the best quality services',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy8',
        screens: blogImg8,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Roger J. Spaulding',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'Quality service in logistics means shipments arrive on time, in good condition, and with clear communication at every step. We focus on dependable execution so customers experience consistency, not surprises.',
        content2: 'Best-quality service is built through trained teams, verified partners, and process checks that catch issues early. From booking to delivery confirmation, every stage is managed with care.',
        content3: 'When service quality is the standard—not the exception—businesses gain stronger customer loyalty and smoother daily operations across their supply chain.',
        quote: 'Service quality is measured in every on-time arrival, every careful handling decision, and every clear update shared with the customer.',
        quoteAuthor: 'Roger J. Spaulding',
        sectionTitle: 'How we deliver quality logistics services',
        points: [
            'Clear timelines and proactive shipment communication.',
            'Careful handling standards for freight integrity.',
            'Verified carriers and controlled service partnerships.',
            'Rapid response when exceptions or delays occur.',
            'Continuous improvement based on customer feedback.',
        ],
        content4: 'We ensure you the best quality services by treating reliability as a daily operating standard. That commitment keeps freight moving smoothly and customers confident in every delivery.',
        tags: ['Service', 'Quality', 'Logistics', 'Delivery'],
    },
    {
        id: '9',
        title: 'Express delivery is going to slow down in 2022',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy9',
        screens: blogImg9,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Aliza Anny',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'Express delivery networks face growing pressure from capacity limits, fuel costs, and rising shipment volumes. Even as customer expectations stay high, many express lanes experience slower transit and tighter cutoffs.',
        content2: 'Businesses that rely on overnight or same-day options need contingency plans—earlier cutoffs, regional stock positioning, and alternate carriers—to protect service levels when express capacity tightens.',
        content3: 'Understanding why express delivery slows down helps operations teams set realistic promises and redesign fulfillment before peak seasons amplify delays.',
        quote: 'When express capacity tightens, the winners are the teams that planned alternatives before the slowdown began.',
        quoteAuthor: 'Aliza Anny',
        sectionTitle: 'Ways to prepare for slower express delivery',
        points: [
            'Review cutoff times and update customer commitments early.',
            'Position inventory closer to high-demand regions.',
            'Secure backup carriers for critical express lanes.',
            'Shift non-urgent shipments to economy modes where possible.',
            'Monitor transit trends and share updates with stakeholders.',
        ],
        content4: 'Express delivery may slow under market pressure, but prepared businesses keep service strong. With smarter planning and flexible options, you can protect delivery promises even when networks tighten.',
        tags: ['Express', 'Delivery', 'Logistics', 'Transport'],
    },
    {
        id: '10',
        title: 'Express delivery is going to slow down in 2022',
        title2: '25 Rules and regulation to be successful in your business.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy90',
        screens: blogImg7,
        description: 'It was with the release sheets containing passages more software.',
        author: 'Aliza Anny',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Culture and Traditions',
        content1: 'Industry signals continue to show that express delivery can slow when demand outpaces available capacity. Congestion, labor constraints, and peak-season surges all contribute to longer transit windows.',
        content2: 'Shippers who depend on speed must balance urgency with cost. Building buffer inventory, improving order cutoffs, and using multimodal alternatives reduces the impact of express slowdowns.',
        content3: 'Staying ahead of delivery trends allows teams to adjust fulfillment strategy before customer experience is affected.',
        quote: 'Speed is valuable—but resilience is what keeps deliveries moving when express networks slow down.',
        quoteAuthor: 'Aliza Anny',
        sectionTitle: 'Actions to protect delivery performance',
        points: [
            'Track express transit times by lane and carrier.',
            'Add lead-time buffers for priority customer orders.',
            'Use regional distribution to shorten last-mile distance.',
            'Evaluate air, road, and hybrid options for urgent freight.',
            'Communicate revised timelines early to avoid surprises.',
        ],
        content4: 'If express delivery slows, proactive logistics planning keeps your business competitive. Adjust early, diversify options, and keep customers informed to maintain trust through every shipment.',
        tags: ['Express', 'Delivery', 'Logistics', 'Transport'],
    },


    


];
export default blogs;
